import "./stylesheets/theme.css";
import "./stylesheets/alignments.css";
import "./stylesheets/textelements.css";
import "./stylesheets/custom-components.css";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ProSidebarProvider } from "react-pro-sidebar";
import { reloadUser } from "./redux/actions/userAction";
import store from "./redux/store";

// Import AdmissionModal component
import AdmissionModal from "./Components/AdmissionModel";

import Home from "./pages/Home";
import Register from "./pages/Register";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

import Layout from "./admin/global/Layout";
import AdminDashboard from "./admin/Dashboard";
import AdminHomeBanner from "./admin/InstituteInfo/HomeBanner";
import AdminHomeHighlights from "./admin/InstituteInfo/HomeHighlights";
import AdminAboutHighlights from "./admin/InstituteInfo/AboutHighlights";
import AdminProfile from "./admin/Profile";
import AdminAdmission from "./admin/Admission/Admission";
import AdminAdmissionGuidelines from "./admin/Admission/AdmissionGuidelines";
import AdminOnlineFees from "./admin/Admission/OnlineFees";
import AdminSchoolFeesManagement from "./admin/SchoolFees/SchoolFees";
import AdminEventsNews from "./admin/EventsNews/EventsNews";
import AdminTeachers from "./admin/Teachers/Teachers";
import AdminCourses from "./admin/Courses/Courses";
import AdminBatch from "./admin/Batch/Batch";
import AdminEnrollStudentBatch from "./admin/Batch/EnrollStudentBatch";
import AdminContact from "./admin/Contact";
import AdminGallery from "./admin/Gallery";
import AdminAllStudentList from "./admin/AllStudentList";
import AdminAcademicCalendar from "./admin/Academic/AcademicCalendar";
import AdminAcademicExamTimeTable from "./admin/Academic/AcademicExamTimeTable";
import AdminExams from "./admin/Exams/Exams";
import AdminAddExamQuestion from "./admin/Exams/AddExamQuestion";
import AdminEditExamQuestion from "./admin/Exams/EditExamQuestion";
import AdminExamReports from "./admin/Exams/Reports";
import AdminGuestStudents from "./admin/Exams/GuestStudents";
import AdminTopRank from "./admin/Exams/TopRank";

import NotFound from "./pages/Error";
import ConnectionStatus from "./Components/ConnectionStatus";

// About Pages
import About from "./pages/About/About";
import Vision from "./pages/About/Vision";
import Mission from "./pages/About/Mission";
import PrincipalDesk from "./pages/About/PrincipalDesk";
import DirectorMessage from "./pages/About/DirectorMessage";

// Admission Pages
import AdmissionProcess from "./pages/Admission/AdmissionProcess";
import OnlineFees from "./pages/Admission/OnlineFees";
import QRPage from "./pages/Admission/QRPage";
import AdmissionForm from "./pages/Admission/AdmissionForm";

// Exams Pages
// import ExamRegistration from "./exams/ExamRegistration";
import AdmitCard from "./exams/AdmitCard";
import OnlineExams from "./exams/OnlineExams";
import Reports from "./exams/Reports";
import TopReports from "./exams/TopReports"

// School Programs Pages
import Navodaya from "./pages/SchoolPrograms/Navodaya";
import Military from "./pages/SchoolPrograms/Military";
import RIMC from "./pages/SchoolPrograms/RIMC";
import Sainik from "./pages/SchoolPrograms/Sainik";

// Student's Corner Pages
import Activities from "./pages/StudentsCorner/Activities";
import Sports from "./pages/StudentsCorner/Sports";
import Environment from "./pages/StudentsCorner/Environment";
import Counselling from "./pages/StudentsCorner/Counselling";

// Academics Pages
import AcademicCalendar from "./pages/AcademicCalendar";
import ExamTimeTable from "./pages/ExamTimeTable";

// Boarders Pages
import HostelFacility from "./pages/Boarders/HostelFacility";
import MessFacility from "./pages/Boarders/MessFacility";
import LibraryFacility from "./pages/Boarders/LibraryFacility";

import Gallery from "./pages/Gallery";
import NewsEvents from "./pages/NewsEvents";
import Contact from "./pages/Contact";

import ControlledSpeedDial from "./Components/ControlledSpeedDial";
import PrivacyPolicy from "./pages/PrivacyPolicy";
// import Instructions from './exams/Instructions';
import WriteExam from "./exams/WriteExam";

function App() {
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const [showAdmissionModal, setShowAdmissionModal] = useState(false);

  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  };



  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      store.dispatch(reloadUser());
    }

    // Show admission modal on every page load after 2 seconds
    const timer = setTimeout(() => {
      setShowAdmissionModal(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);


   useEffect(() => {
    const disableContextMenu = (e) => {
      e.preventDefault();
      // message.warning("Right-click is disabled on this website.");
    };

    // document.addEventListener('copy', disableCopy);
    document.addEventListener('contextmenu', disableContextMenu);

    return () => {
      // document.removeEventListener('copy', disableCopy);
      document.removeEventListener('contextmenu', disableContextMenu);
    };
  }, []);

  const AdminDashboardHDC = Layout(AdminDashboard);
  const AdminHomeBannerHDC = Layout(AdminHomeBanner);
  const AdminHomeHighlightsHDC = Layout(AdminHomeHighlights);
  const AdminAboutHighlightsHDC = Layout(AdminAboutHighlights);
  const AdminProfileHDC = Layout(AdminProfile);
  const AdminAdmissionHDC = Layout(AdminAdmission);
  const AdminAdmissionGuidelinesHDC = Layout(AdminAdmissionGuidelines);
  const AdminOnlineFeesHDC = Layout(AdminOnlineFees);
  const AdminSchoolFeesManagementHDC = Layout(AdminSchoolFeesManagement);
  const AdminEventsNewsHDC = Layout(AdminEventsNews);
  const AdminTeachersHDC = Layout(AdminTeachers);
  const AdminCoursesHDC = Layout(AdminCourses);
  const AdminBatchHDC = Layout(AdminBatch);
  const AdminEnrollStudentBatchHDC = Layout(AdminEnrollStudentBatch);
  const AdminContactHDC = Layout(AdminContact);
  const AdminGalleryHDC = Layout(AdminGallery);
  const AdminAllStudentListHDC = Layout(AdminAllStudentList);
  const AdminAcademicCalendarHDC = Layout(AdminAcademicCalendar);
  const AdminAcademicExamTimeTableHDC = Layout(AdminAcademicExamTimeTable);
  const AdminExamsHDC = Layout(AdminExams);
  const AdminAddExamQuestionsHDC = Layout(AdminAddExamQuestion);
  const AdminEditExamQuestionHDC = Layout(AdminEditExamQuestion);
  const AdminExamReportsHDC = Layout(AdminExamReports);
  const AdminExamStudentListHDC = Layout(AdminGuestStudents);
  const AdminTopRankHDC = Layout(AdminTopRank);

  return (
    <>
      <ConnectionStatus />
      {user && user.role >= 1 ? null : <ControlledSpeedDial />}

      {/* Admission Modal - Will appear on page load */}
      <AdmissionModal
        open={showAdmissionModal}
        onClose={() => setShowAdmissionModal(false)}
      />

      <ProSidebarProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/dashboard"
              element={
                isAuthenticated ? (
                  user ? (
                    user.role === 0 ? (
                      <Home />
                    ) : user.role >= 1 ? (
                      <AdminDashboardHDC />
                    ) : (
                      <Home />
                    )
                  ) : (
                    <Login />
                  )
                ) : (
                  <Login />
                )
              }
            />

            {/* Common Routes  */}
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/password/forgot" element={<ForgotPassword />} />
            <Route path="/password/reset/:token" element={<ResetPassword />} />

            {/* Pages Routes */}
            <Route path="/admission-process" element={<AdmissionProcess />} />
            <Route path="/online-exams" element={<OnlineExams />} />
            {/* <Route path="/register-exam" element={<ExamRegistration />} /> */}
            <Route path="admit-card" element={<AdmitCard />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/top-reports" element={<TopReports />} />
            <Route path="/admission-form" element={<AdmissionForm />} />  
            <Route path="/online-fees" element={<OnlineFees />} />
            <Route path="/write-exam/:id" element={<WriteExam />} />
            <Route path="/qr-page" element={<QRPage />} />

            <Route path="/about-school" element={<About />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/mission" element={<Mission />} />
            <Route path="/director-message" element={<DirectorMessage />} />
            <Route path="/principal-desk" element={<PrincipalDesk />} />
            <Route path="/navodaya" element={<Navodaya />} />
            <Route path="/military" element={<Military />} />
            <Route path="/RIMC" element={<RIMC />} />
            <Route path="/sainik" element={<Sainik />} />

            <Route path="/activities" element={<Activities />} />
            <Route path="/sports" element={<Sports />} />
            <Route path="/environment" element={<Environment />} />
            <Route path="/counselling" element={<Counselling />} />

            <Route path="/academic-calendar" element={<AcademicCalendar />} />
            <Route
              path="/academic-exam-time-table"
              element={<ExamTimeTable />}
            />

            <Route path="/hostel-facility" element={<HostelFacility />} />
            <Route path="/mess-facility" element={<MessFacility />} />
            <Route path="/library-facility" element={<LibraryFacility />} />

            <Route path="/news-events" element={<NewsEvents />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            {/* Admin Routes */}
            {user?.role >= 1 ? (
              <>
                <Route
                  path="/admin/institute/home"
                  element={<AdminHomeBannerHDC />}
                />
                <Route
                  path="/admin/institute/home-highlights"
                  element={<AdminHomeHighlightsHDC />}
                />
                <Route
                  path="/admin/institute/about"
                  element={<AdminAboutHighlightsHDC />}
                />
                <Route path="/admin/profile" element={<AdminProfileHDC />} />
                <Route
                  path="/admin/admission"
                  element={<AdminAdmissionHDC />}
                />
                <Route
                  path="/admin/admission-guidelines"
                  element={<AdminAdmissionGuidelinesHDC />}
                />
                <Route
                  path="/admin/online-fees"
                  element={<AdminOnlineFeesHDC />}
                />
                <Route
                  path="/admin/school-fees-management"
                  element={<AdminSchoolFeesManagementHDC />}
                />
                <Route
                  path="/admin/events-news"
                  element={<AdminEventsNewsHDC />}
                />
                <Route path="/admin/teachers" element={<AdminTeachersHDC />} />
                <Route path="/admin/courses" element={<AdminCoursesHDC />} />
                <Route path="/admin/batch" element={<AdminBatchHDC />} />
                <Route
                  path="/admin/enroll/student"
                  element={<AdminEnrollStudentBatchHDC />}
                />
                <Route path="/admin/contact" element={<AdminContactHDC />} />
                <Route path="/admin/gallery" element={<AdminGalleryHDC />} />
                <Route
                  path="/admin/student/list"
                  element={<AdminAllStudentListHDC />}
                />
                <Route
                  path="/admin/academic-calendar"
                  element={<AdminAcademicCalendarHDC />}
                />
                <Route
                  path="/admin/academic-exam-time-table"
                  element={<AdminAcademicExamTimeTableHDC />}
                />
                <Route path="/admin/exams" element={<AdminExamsHDC />} />
                <Route
                  path="/admin/add/exam"
                  element={<AdminAddExamQuestionsHDC />}
                />
                <Route
                  path="/admin/edit/exam/:id"
                  element={<AdminEditExamQuestionHDC />}
                />
                <Route
                  path="/admin/reports"
                  element={<AdminExamReportsHDC />}
                />
                <Route
                  path="/admin/guest/students"
                  element={<AdminExamStudentListHDC />}
                />

                 <Route
                  path="/admin/top/reports"
                  element={<AdminTopRankHDC />}
                />
                {/* </Route> */}
              </>
            ) : null}
            {/* Page not found Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </ProSidebarProvider>
    </>
  );
}

export default App;
